import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import ContractAnagementFlow from '@/types/table/contractAnagementFlow';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface ContractAnagementFlowData extends ContractAnagementFlow {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class ContractAnagementFlowController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<ContractAnagementFlowData>>(API_CONTEXT + '/app/contractAnagementFlow/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<ContractAnagementFlowData>(API_CONTEXT + '/app/contractAnagementFlow/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/contractAnagementFlow/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/contractAnagementFlow/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/contractAnagementFlow/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/contractAnagementFlow/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/contractAnagementFlow/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/contractAnagementFlow/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/contractAnagementFlow/deleteBatch', params, httpOptions);
  }
  static startOnlyFlowContract(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/contractAnagementFlow/startOnly/FlowContract', params, httpOptions);
  }
  static startWithBusinessKeyFlowContract(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/contractAnagementFlow/startWithBusinessKey/FlowContract', params, httpOptions);
  }
  static startAndTakeUserTaskFlowContract(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/contractAnagementFlow/startAndTakeUserTask/FlowContract', params, httpOptions);
  }

  static editorTakeUserTaskFlowContract(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/contractAnagementFlow/editorTakeUserTaskFlowContract/editUserTaskFlowContract', params, httpOptions);
  }
  static startAndSaveDraftFlowContract(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/contractAnagementFlow/startAndSaveDraft/FlowContract', params, httpOptions);
  }
  static submitUserTaskFlowContract(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/contractAnagementFlow/submitUserTask/FlowContract', params, httpOptions);
  }
  static viewTaskBusinessDataFlowContract(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/app/contractAnagementFlow/viewTaskBusinessData/FlowContract', params, httpOptions);
  }
  static viewHistoricTaskBusinessDataFlowContract(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/app/contractAnagementFlow/viewHistoricTaskBusinessData/FlowContract', params, httpOptions);
  }
  static listWorkOrderFlowContract(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/contractAnagementFlow/listWorkOrder/FlowContract', params, httpOptions);
  }
  static deleteMessage(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/dept/deleteMessage', params, httpOptions);
  }

  static getUserInformationByUserId(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/contractAnagementFlow/getUserInformation', params, httpOptions);
  }

  static taskInvalidated(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/contractAnagementFlow/taskInvalidated', params, httpOptions);
  }

  /**
   * 合同申请数据集（根据工单ID）
   */
  static getContractApplicationDataset(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/contractAnagementFlow/getContractApplicationDataset', params, httpOptions);
  }

  // 律师端更新合同
  static lawyerUpdate(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/contractAnagementFlow/lawyerUpdate', params, httpOptions);
  }
}
